module.exports = __webpack_public_path__ + "img/BA.21a9ce1a.png";